export default "__VITE_ASSET__CYcAdc7z__"